/**
 * Configuración global de actions
 */
export const DO_ROUTE = "DO_ROUTE";
export const DO_IS_LOADING = "DO_IS_LOADING";
export const DO_IS_LOADING_WITH_CONTENT = "DO_IS_LOADING_WITH_CONTENT";
export const DO_REQUEST_API = "DO_REQUEST_API";
export const DO_LANDING = "DO_LANDING";
export const DO_LANDING_SUCCESS = "DO_LANDING_SUCCESS";
export const DO_LANDING_ERROR = "DO_LANDING_ERROR";
export const DO_GRACIAS = "DO_GRACIAS";
export const DO_MENSAJE = "DO_MENSAJE";
export const DO_NOTIFICATION_TOAST = "DO_NOTIFICATION_TOAST";
export const DO_NOTIFICATION_TOAST_RESET = "DO_NOTIFICATION_TOAST_RESET";
export const DO_FORZAR_DNE = "DO_FORZAR_DNE";
export const DO_CONSULTAR = "DO_CONSULTAR";
export const DO_CONTACTO_PH = "DO_CONTACTO_PH";
export const DO_CONSULTA_PH = "DO_CONSULTA_PH";
export const DO_CONSULTA_PH_INCOME = "DO_CONSULTA_PH_INCOME";
export const DO_CONFIRMAR_SIMULACION_PH = "DO_CONFIRMAR_SIMULACION_PH";
export const DO_UPDATE_CONSULTA = "DO_UPDATE_CONSULTA";
export const DO_RECALCULO = "DO_RECALCULO";
export const DO_ENVIAR_MAIL = "DO_ENVIAR_MAIL";
export const DO_CONSULTA_ERROR = "DO_CONSULTA_ERROR";
export const DO_CONSULTA_SUCCESS = "DO_CONSULTA_SUCCESS";
export const DO_PRIMERA_CONSULTA_SUCCESS = "DO_PRIMERA_CONSULTA_SUCCESS";
export const DO_ENVIAR_MAIL_SUCCESS = "DO_ENVIAR_MAIL_SUCCESS";
export const DO_ENVIAR_MAIL_ERROR = "DO_ENVIAR_MAIL_ERROR";
export const DO_LANDING_QR = "DO_LANDING_QR";
export const DO_SOLICITAR_PASO1 = "DO_SOLICITAR_PASO1";
export const DO_PASO1 = "DO_PASO1";
export const DO_PASO2 = "DO_PASO2";
export const DO_PASO3 = "DO_PASO3";
export const DO_DIA_DEBITO = "DO_DIA_DEBITO";
export const DO_DIGITAL = "DO_DIGITAL";
export const DO_PRESENCIAL = "DO_PRESENCIAL";
export const DO_DATA_AUTH_ASO = "DO_DATA_AUTH_ASO";
export const DO_ENVIAR_EVENTO_DVS_FS = "DO_ENVIAR_EVENTO_DVS_FS";
export const GET_REINTENTOS_BIO = "GET_REINTENTOS_BIO";
export const GET_VERIDAS_IFRAME = "GET_VERIDAS_IFRAME";
export const GET_VERIDAS_RESULT = "GET_VERIDAS_RESULT";
export const GET_RENAPER_VALIDATION = "GET_RENAPER_VALIDATION";
export const DO_ENVIAR_RESULTADOS_BIOMETRIA = "DO_ENVIAR_RESULTADOS_BIOMETRIA";
export const DO_POST_FRONT_DNI = "DO_POST_FRONT_DNI";
export const DO_POST_REVERSE_DNI = "DO_POST_REVERSE_DNI";
export const DO_POST_SELFIE = "DO_POST_SELFIE";
export const DO_POST_SELFIE_ALIVE = "DO_POST_SELFIE_ALIVE";
export const DO_POST_SELFIES = "DO_POST_SELFIES";
export const DO_POST_SELFIES_PROMISE = "DO_POST_SELFIES_PROMISE";
export const DO_VALIDAR_EN_SUCURSAL = "DO_VALIDAR_EN_SUCURSAL";
export const DO_DECRYPT_HR_DATOS = "DO_DECRYPT_HR_DATOS";
export const DO_ERROR_SELFIES = "DO_ERROR_SELFIES";
export const DO_CONFIRMACION = "DO_CONFIRMACION";
export const DO_FETCH_SUCURSALES = "DO_FETCH_SUCURSALES";
export const DO_PRELOAD_SDK = "DO_PRELOAD_SDK";
export const DO_IS_VISIBLE_SDK = "DO_IS_VISIBLE_SDK";
export const DO_SAVE_IFRAME = "DO_SAVE_IFRAME";
export const DO_SEARCH_CONTRACTS = "DO_SEARCH_CONTRACTS";
export const DO_SIGN_CONTRACTS = "DO_SIGN_CONTRACTS";
export const DO_NORMALIZE = "DO_NORMALIZE";
export const DO_SELECT_DOMICILIO_NORMALIZADO_PARTICULAR =
  "DO_SELECT_DOMICILIO_NORMALIZADO_PARTICULAR";
export const DO_SELECT_DOMICILIO_NORMALIZADO_ALTERNATIVO =
  "DO_SELECT_DOMICILIO_NORMALIZADO_ALTERNATIVO";
export const DO_VALIDAR_CELULAR = "DO_VALIDAR_CELULAR";
export const DO_ENVIO_CELULAR = "DO_ENVIO_CELULAR";
export const DO_CREAR_USUARIO = "DO_CREAR_USUARIO";
export const DO_NORMALIZARCELULAR = "DO_NORMALIZARCELULAR";
export const DO_ACTUALIZAR_ESTADO_TYC = "DO_ACTUALIZAR_ESTADO_TYC";
export const ON_TCODE = "ON_TCODE";
export const SET_ADOBE_TARGET_EXPERIENCE = "SET_ADOBE_TARGET_EXPERIENCE";
export const DO_GET_TOKEN_USER_ID = "DO_GET_TOKEN_USER_ID";
export const DO_GET_DEVICEID = "DO_GET_DEVICEID";
export const DO_GET_DEVICEIDTIMESTAMP = "DO_GET_DEVICEIDTIMESTAMP";
export const DO_GET_LINEAS_PH = "DO_GET_LINEAS_PH";
export const DO_SEND_SMS = "DO_SEND_SMS";
export const DO_CONFIRMAR_RENAPER = "DO_CONFIRMAR_RENAPER";
export const DO_CONSULTA_RENAPER = "DO_CONSULTA_RENAPER";
export const DO_ENVIAR_RENAPER = "DO_ENVIAR_RENAPER";
export const DO_FECHA_SISTEMA = "DO_FECHA_SISTEMA";
export const DO_SET_MAX_AMOUNT = "DO_SET_MAX_AMOUNT";
export const DO_COTIZACION = "DO_COTIZACION";
export const DO_PRESCRIPTOR = "DO_PRESCRIPTOR";
export const DO_CONFIRMAR_PRESCRIPTOR = "DO_CONFIRMAR_PRESCRIPTOR";
export const DO_GUARDAR_LEAD_PH = "DO_GUARDAR_LEAD_PH";
export const DO_ACORTAR_URL = "DO_ACORTAR_URL";
export const DO_URI_POR_UID = "DO_URI_POR_UID";
